/* ww-home.js - WaveWear home page, native
   <ww-carousel> : scroll-snap horizontal carousel + arrow state */
(function () {
  if (window.customElements && customElements.get('ww-carousel')) return;

  class WWCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ww-wc__track');
      this.prev = this.querySelector('.ww-wc__arrow--prev');
      this.next = this.querySelector('.ww-wc__arrow--next');
      if (!this.track) return;

      this.onScroll = this.update.bind(this);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      if (this.prev) this.prev.addEventListener('click', () => this.step(-1));
      if (this.next) this.next.addEventListener('click', () => this.step(1));

      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(() => this.update());
        this.ro.observe(this.track);
      } else {
        window.addEventListener('resize', this.onScroll);
      }

      // images can land late and change the width
      this.update();
      window.setTimeout(() => this.update(), 400);
      window.setTimeout(() => this.update(), 1500);
    }

    disconnectedCallback() {
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      if (this.ro) this.ro.disconnect();
      window.removeEventListener('resize', this.onScroll);
    }

    slideWidth() {
      const slide = this.track.querySelector('.ww-wc__slide');
      if (!slide) return this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap || '0') || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    step(dir) {
      this.track.scrollBy({ left: this.slideWidth() * dir, behavior: 'smooth' });
    }

    update() {
      // treat "within the track's left padding" as the start:
      // scroll-snap can absorb the padding and park scrollLeft at it
      const padL = parseFloat(getComputedStyle(this.track).paddingLeft || '0') || 0;
      const max = this.track.scrollWidth - this.track.clientWidth;
      const x = this.track.scrollLeft;
      const scrollable = max > padL + 4;
      if (this.prev) this.prev.hidden = !scrollable || x <= padL + 2;
      if (this.next) this.next.hidden = !scrollable || x >= max - 2;
    }
  }

  if (window.customElements) customElements.define('ww-carousel', WWCarousel);
})();
